module.exports = "<p>\r\n  awsop-lab4 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab4/awsop-lab4.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab4/awsop-lab4.component.html
// module chunks = main